const menuTag = 'menu_event';

export class MenuEvents {
    addMenuListener(callback) {
        document.addEventListener(menuTag, callback); // eslint-disable-line
    }

    dispatchMenuEvent(path) {
        document.dispatchEvent(new CustomEvent(menuTag, { detail: path })); // eslint-disable-line
    }

    removeMenuListener(callback) {
        document.removeEventListener(menuTag, callback); // eslint-disable-line
    }
}
